import restService from "./rest.service";

async function loginBase(url, credentials) {
    localStorage.clear();

    const {
        data: { success, token, user, mensagem, message, error, portal },
    } = await restService.postAsync(url, credentials);

    localStorage.setItem("token", token);

    if (user) {
        localStorage.setItem("user", user);
    }

    if (mensagem) return { success, user, message: mensagem, portal, error, token };
    return { success, user, message, portal, error, token };
}

//Para que o request funcione corretamente, eh necessario que os parametros estejam com os mesmos nomes do metodo no server
async function loginAsync(credentials) {
    return loginBase("auth/login", credentials);
}

async function loginMedicoAsync(credentials) {
    return loginBase("auth/loginMedico", credentials);
}

async function loginConvenioAsync(credentials) {
    return loginBase("auth/loginConvenio", credentials);
}

async function loginProcedenciaAsync(credentials) {
    return loginBase("auth/loginProcedencia", credentials);
}

async function loginPacienteTokenAsync(credentials) {
    return loginBase("auth/loginToken", credentials);
}

async function loginMedicoTokenAsync(credentials) {
    return loginBase("auth/loginMedicoToken", credentials);
}

async function loginColaborador(credentials) {
    return await restService.postAsync("auth/LoginMedicoColaborador", credentials);
}

export default {
    loginAsync,
    loginMedicoAsync,
    loginConvenioAsync,
    loginProcedenciaAsync,
    loginPacienteTokenAsync,
    loginMedicoTokenAsync,
    loginColaborador,
};
